import { Client } from "lib/eduConfigurationServiceClient";
import HttpClient from "@/utils/httpClient";

export const eduConfigurationServiceClient = new Client(
  undefined,
  HttpClient.educonfig,
);
